import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'infoAggBet'
})
export class InfoAggBetPipe implements PipeTransform {

  transform(value: string, cod: number, numberHorse?: boolean): string {

    // Bet Short M (X) - Not Place 2 - 3 - 4
    if (numberHorse) {
      return String(parseInt(value.substr(6, 2), 16));
    }

    // Bet Lenghts (X)
    if (Number(cod) === 16) {
      return String(parseInt(value.substr(2, 2), 16));
    }

    // Bet Dispersion (X)
    if (Number(cod) === 18) {
      return String(parseInt(value.substr(2, 2), 16)) + '.' + String(parseInt(value.substr(0, 2), 16));
    }
    return '';
  }

}
